import { getDeviceType } from '@picsart/design-system/foundation/utils';

export const isDesktop = getDeviceType() === 'Desktop';
export const isTablet = getDeviceType() === 'Tablet';
export const isMobile = getDeviceType() === 'Mobile';
